import { render } from "./detail-layout.vue?vue&type=template&id=38cffc80&scoped=true&ts=true"
import script from "./detail-layout.vue?vue&type=script&lang=ts"
export * from "./detail-layout.vue?vue&type=script&lang=ts"

import "./detail-layout.vue?vue&type=style&index=0&id=38cffc80&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-38cffc80"]])

export default __exports__